import {ChangeDetectionStrategy, Component, Input, OnInit} from "@angular/core";

@Component({
    selector: 'app-message-banner',
    templateUrl: './message-banner.component.html',
    styleUrls: ['./message-banner.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MessageBannerComponent implements OnInit {
  @Input() message: String;
  @Input() type: "WARNING" | "INFO";

  constructor() { }

  ngOnInit() {
  }

}
